export function getSubstringBefore (str: string, match: string) {
  return str.substring(0, str.toLowerCase().indexOf(match.toLowerCase()));
}

export function getSubstringAfter (str: string, match: string) {
  return str.substring(str.toLowerCase().indexOf(match.toLowerCase()) + match.length, str.length);
}

export function replaceLast (str: string, replacer: string, newWord = '') {
  const lastIndexOfLastPart = str.lastIndexOf(replacer);
  return str.slice(0, lastIndexOfLastPart) + str.slice(lastIndexOfLastPart).replace(replacer, newWord);
}